// 🔧 demo_compatibility.js
// ✅ Purpose: Compatibility helpers during Demo Engine migration
// ✅ Features:
// - Allows legacy demo creation code to consume Demo Engine results
// - Keeps migration incremental and low-risk
// - Eliminates duplicate orchestration logic
// - Future removal after migration completes
// - Fully block-commented for clarity and future devs

import { logger } from "../../utils/logger";

export const buildLegacyDemoResult = ({
  demoEngineResult,
} = {}) => {
  logger.log("🧪 Building legacy Demo Engine compatibility result.");

  if (!demoEngineResult) {
    return null;
  }

  return {
    ...demoEngineResult,

    legacyCompatibility: true,
  };
};